<template>
  <div id="app" >
      <router-view/>
      <headers ref="headers" @loglog="loglog"  v-if="$route.path != '/' && $route.path != '/chat'"></headers>
  </div>
</template>


<script>
import headers from '../src/common/Headers.vue'
export default {
     components: {
      headers
  },
  data () {
    return {
      }
  },
  created () {
  },
  methods: {
    loglog (e) {
      this.$router.replace(e)
      this.$refs.headers.onClose()
      }
    }
}
</script>
<style lang="scss" scoped>
#app{
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
</style>
